/**
 * =============================================================================
 * searchanise-integration.js
 * =============================================================================
 * Listens for Searchanise AddToCartSuccess and opens/refreshes the offcanvas cart
 * =============================================================================
 */

function initSearchaniseAddToCartListener() {
  const $ = window.Searchanise?.$;
  if (!$) return;

  $(document).on('Searchanise.AddToCartSuccess', function(event, add_to_cart_id, product) {
    if (window.MP?.Extensions?.Cart?.fetchAndRenderMinicart) {
      window.MP.Extensions.Cart.fetchAndRenderMinicart(true);
    }
  });
}

function setupSearchaniseIntegration() {
  if (window.Searchanise?.$) {
    initSearchaniseAddToCartListener();
  } else {
    document.addEventListener('Searchanise.Loaded', initSearchaniseAddToCartListener);
  }
}

var SearchaniseIntegration = {
  init: function() {
    setupSearchaniseIntegration();
  }
};

export default SearchaniseIntegration;
